import React, { useEffect } from 'react';
import { useAuth } from "react-oidc-context";

import { Stepper, Step } from "react-form-stepper";
import { Container, Row, Col } from 'react-bootstrap';
import { get_user_paths_and_files, upload_file_to_aws, get_s3_signed_url, update_file_log } from "../../services/apiCallerService/GraphqlCaller";
import { get_token } from "../../services/tools/SessionTools";
import PathSelector from "./Step1_PathSelector";
import FileUploader from "./Step2_FileUploader";
import Confirmation from "./Step3_Confirmation";
import UploadError from "./Step4_UploadError";
//import { PrimaryButton, SecondaryButton, Loader } from '@ttd/lingo';
import { Button, Alert, Modal, Spin } from 'antd';

export default function FileWizard() {
  const auth = useAuth();


  const [selectedFile, setSelectedFile] = React.useState<any>(null);
  const [bucketsWithFiles, setBucketsWithFiles] = React.useState<any>(null);
  const [selectedPath, setSelectedPath] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(true);
  const [uploading, setUploading] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState("PathSelector");
  const [error, setError] = React.useState(0);



  const reset = () => {
    window.location.reload();
  }

  const next_step = () => {
    switch (activeStep) {
      case "PathSelector":
        setActiveStep("FileUploader");
        break;
      case "FileUploader":
        setActiveStep("Confirmation");
        break;
      default:
        break;
    }
  }

  const show_error = (error_message: any) => {
    setError(error_message);
    setActiveStep("Error");
  }

  const set_step_value = (path: any) => {
    setSelectedPath(path);
  }


  const set_selected_file_for_upload = (file: any) => {
    setSelectedFile(file);
  }

  // Helper function to update file log and handle errors
  const updateFileLogSafely = async (token: any, fileLogId: string, status: string) => {
    try {
      await update_file_log(token, fileLogId, status);
      console.log(`File log updated to ${status} successfully`);
    } catch (err) {
      console.error("Failed to update file log:", err);
    }
  };

  // Helper function to handle S3 upload
  const handleS3Upload = async (
    signed_url: string,
    metadataUsername: string | null,
    includeUsernameMetadata: boolean,
    fileLogId: string | null,
    token: any
  ) => {
    try {
      const res = await upload_file_to_aws(signed_url, selectedFile, metadataUsername, includeUsernameMetadata);

      if (res === 200) {
        // Upload successful - update file log for backend verification
        if (fileLogId) {
          await updateFileLogSafely(token, fileLogId, "AwaitingVerification");
        }
        setActiveStep("Confirmation");
      } else {
        // Upload failed
        if (fileLogId) {
          await updateFileLogSafely(token, fileLogId, "Failed");
        }
        show_error(res);
      }
    } catch (error2) {
      console.log("Something went wrong with uploading file");
      console.log(error2);
      // Update file log as failed
      if (fileLogId) {
        await updateFileLogSafely(token, fileLogId, "Failed");
      }
    }
  };

  const upload_file = async (path_setting: any, selectedFileName: any) => {
    const token = auth.user;
    const username = auth.user?.profile?.email;

    if (!username) {
      show_error("User not found");
      return;
    }

    setUploading(true);

    path_setting["filename"] = selectedFileName;
    path_setting["user"] = username;

    try {
      // Get signed URL
      const signed_url_res = await get_s3_signed_url(token, path_setting);
      const signed_url = signed_url_res["url"];
      const success = signed_url_res["success"];
      const includeUsernameMetadata = signed_url_res["includeUsernameMetadata"] ?? true;
      const metadataUsername: string | null = signed_url_res["metadataUsername"] ?? null;
      const fileLogId = signed_url_res["fileLogId"];

      // Handle signed URL generation failure
      if (success === false) {
        setUploading(false);
        show_error(signed_url_res["statusCode"]);
        if (fileLogId) {
          await updateFileLogSafely(token, fileLogId, "Failed");
        }
        return;
      }

      // Proceed with upload if signed URL is valid
      if (signed_url !== "") {
        await handleS3Upload(signed_url, metadataUsername, includeUsernameMetadata, fileLogId, token);
      }
    } catch (error) {
      console.log("Something went wrong with signed url");
      console.log(error);
      setUploading(false);
      show_error(error);
    }
  };




  useEffect(() => {
    if (bucketsWithFiles === null) {
      const token = get_token(auth);

      get_user_paths_and_files(token)
        .then((res: any) => {
          setBucketsWithFiles(res);
          setLoading(false);
        })
        .catch(function (error) {
          console.error("Error fetching paths and files:", error);
          setBucketsWithFiles([]);
          setLoading(false);
        });
    }
  }, [bucketsWithFiles, auth]);


  return (
    <div>

      <Container>
        <Row>
          <Col>
            <Stepper activeStep={["PathSelector", "FileUploader", "Confirmation"].indexOf(activeStep)}>
              <Step label="Select Destination" />
              <Step label="Upload File" />
              <Step label="Confirmation" />
            </Stepper>
          </Col>
        </Row>
        <Row>
          <Col>

            {activeStep == "PathSelector" &&
              <div>
                <PathSelector
                  stepName={"PathSelector"}
                  on_path_change={(path: any) => set_step_value(path)}
                  selectedPath={selectedPath}
                  loading={loading}
                  bucketsWithFiles={bucketsWithFiles ?? []}
                  token={get_token(auth)} />

                <div className="btn-group-wizzard">
                  {selectedPath == null ? (
                    <span className="btn-disabled-wrapper">
                      <Button
                        as="button"
                        data-ttd-inspect-id="next-step-button"
                        onClick={(e: any) => e.preventDefault()}>
                        Next
                      </Button>
                    </span>
                  ) : (
                    <Button
                      as="button"
                      data-ttd-inspect-id="next-step-button"
                      onClick={() => next_step()}>
                      Next
                    </Button>
                  )}
                </div>
              </div>
            }
            {activeStep == "FileUploader" &&
              <div style={{ position: 'relative' }}>
                {uploading && (
                  <div className="wizard-upload-overlay">
                    <Spin />
                    <p>Uploading…</p>
                  </div>
                )}

                <FileUploader
                  stepName={"FileUploader"}
                  selectedPath={selectedPath}
                  set_selected_file={(file: any) => set_selected_file_for_upload(file)}
                  show_error={(error: any) => setError(error)} />

                <div className="btn-group-wizzard">
                  <Button
                    disabled={uploading}
                    onClick={() => reset()}>
                    Back
                  </Button>

                  {selectedFile === null || uploading ? (
                    <span className="btn-disabled-wrapper">
                      <Button
                        disabled={uploading}
                        onClick={(e: any) => e.preventDefault()}>
                        Upload
                      </Button>
                    </span>
                  ) : (
                    <Button
                      onClick={() => upload_file(selectedPath, selectedFile.name)}>
                      Upload
                    </Button>
                  )}
                </div>
              </div>
            }

            {activeStep == "Confirmation" &&
              <div>
                <Confirmation />
                <div className="btn-group-wizzard">
                  <Button
                    onClick={() => reset()}>
                    Back
                  </Button>
                </div>
              </div>
            }


            {activeStep == "Error" &&
              <div>
                <UploadError
                  stepName={"Error"}
                  error={error} />

                <Button
                  onClick={() => reset()}>
                  Back
                </Button>
              </div>
            }
          </Col>
        </Row>

      </Container>
    </div>
  );
}
